module.exports = __webpack_public_path__ + "img/audi-logo.8b7060dc.webp";